// get company assets table data
export const getCompanyAssetFields = (state) => {
  return state.serviceDesk?.assets?.company?.data?.assetFields;
};

// get company assets table data
export const getCompanyAssets = (state) => {
  const companyData = state.serviceDesk?.assets?.company?.data;
  // const error = companyData?.error;
  const assets = companyData?.assets || {};

  const formatData = () => {
    if (!assets) return [];

    return Object.values(assets).map(item => {
      const fields = item.asset_values ? Object.values(item.asset_values) : [];

      return {
        ...item,
        asset_values: fields.reduce((acc, field) => {
          if (field?.field_name) acc[field.field_name] = field;
          return acc;
        }, {}),
      };
    });
  };

  return formatData();
};

// get site asset fields data
export const getSiteAssetFields = (state) => {
  return state.serviceDesk?.assets?.site?.data?.assetFields;
};

// get site assets table data
export const getSiteAssets = (state) => {
  const siteData = state.serviceDesk?.assets?.site?.data;
  const error = siteData?.error;
  const assets = siteData?.assets || {};

  const formatData = () => {
    if (!assets) return [];

    return Object.values(assets).map(item => {
      const fields = item.asset_values ? Object.values(item.asset_values) : [];

      return {
        ...item,
        asset_values: fields.reduce((acc, field) => {
          if (field?.field_name) acc[field.field_name] = field;
          return acc;
        }, {}),
      };
    });
  };

  return {
    getSiteAssetsData: formatData(),
    getSiteAssetsError: error,
  };
};

// get site asset id
export const getAssetId = (state) => {
  return state.serviceDesk?.assets?.site?.data?.assetId;
}

// get site asset id
export const getSiteAssetViewUid = (state) => {
  return state.serviceDesk?.assets?.siteView?.data?.assetUid;
}

// get site asset id
export const getPageLimit = (state) => {
  return state.serviceDesk?.assets?.site?.data?.pagination?.perPage;
}